import { memo } from 'react'

import { ICON_CHEVRON_DIRECTION } from '../../Icon'
import { TableScrollButton } from '../TableScrollButton'

import * as styles from './TableScrollButtonOverlay.module.css'

function TableScrollButtonOverlay({
  isIntersectingLeftEnd,
  isIntersectingRightEnd,
  isLoading,
  onScrollLeft,
  onScrollRight,
}) {
  return (
    <>
      <TableScrollButton
        className={styles.leftArrow}
        direction={ICON_CHEVRON_DIRECTION.LEFT}
        visible={!isIntersectingLeftEnd && !isLoading}
        onClick={onScrollLeft}
      />

      <TableScrollButton
        className={styles.rightArrow}
        visible={!isIntersectingRightEnd && !isLoading}
        onClick={onScrollRight}
      />
    </>
  )
}

export default memo(TableScrollButtonOverlay)
